import { UploadReqPageComponent } from "./upload-req-page.component";
export const UploadReqPageModule = angular
    .module('uploadReqPage', [])
    .config(['$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('missioncontrol.uploadreq', {
            url: '/uploadreq',
            component: UploadReqPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                jobId: null,
                jobState: null,
                isNewReq: null,
                asyncActionType: null,
                workflowSteps: null,
                fourDotFiveIntelligentThresholdScore: null,
                vendorsDetails: null
            }
        });
    }
])
    .component(UploadReqPageComponent.selector, UploadReqPageComponent.component)
    .name;
//# sourceMappingURL=upload-req-page.module.js.map